module.exports = __webpack_public_path__ + "static/media/marek-okon-t-ww-cq-i-mi-umg-unsplash-1@3x.d833a17b.jpg";